import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { TriangleDownIcon, TriangleUpIcon } from "./number-input.icons";
import { chakra, forwardRef, ThemingProvider, useThemingContext } from "@chakra-ui/system";
import { createContext, __DEV__ } from "@chakra-ui/utils";
import * as React from "react";
import { useNumberInput } from "./use-number-input";
/**
 * React context used to communicate between components
 */

var _createContext = createContext({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext must be used within NumberInputContextProvider "
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    NumberInputContextProvider = _createContext2[0],
    useNumberInputContext = _createContext2[1];
/**
 * NumberInput - Theming
 *
 * To style the number input's container globally, change the styles in
 * `theme.components.NumberInput` under the `Root` key
 */


var StyledRoot = chakra("div", {
  themeKey: "NumberInput.Root",
  baseStyle: {
    position: "relative"
  }
});
/**
 * NumberInput
 *
 * React component that provides context and logic to all
 * number input sub-components.
 *
 * It renders a `div` by default.
 *
 * @see Docs http://chakra-ui.com/numberinput
 */

export var NumberInput = /*#__PURE__*/React.forwardRef(function NumberInput(props, ref) {
  var size = props.size,
      variant = props.variant,
      colorScheme = props.colorScheme,
      hookProps = _objectWithoutPropertiesLoose(props, ["size", "variant", "colorScheme"]);

  var theming = {
    size: size,
    variant: variant,
    colorScheme: colorScheme
  };

  var _useNumberInput = useNumberInput(hookProps),
      htmlProps = _useNumberInput.htmlProps,
      context = _objectWithoutPropertiesLoose(_useNumberInput, ["htmlProps"]);

  var _context = React.useMemo(function () {
    return context;
  }, [context]);

  return /*#__PURE__*/React.createElement(ThemingProvider, {
    value: theming
  }, /*#__PURE__*/React.createElement(NumberInputContextProvider, {
    value: _context
  }, /*#__PURE__*/React.createElement(StyledRoot, _extends({
    ref: ref
  }, theming, htmlProps))));
});

if (__DEV__) {
  NumberInput.displayName = "NumberInput";
}
/**
 * NumberInputStepper - Theming
 *
 * To style the number input button group globally, change the styles in
 * `theme.components.NumberInput` under the `StepperGroup` key
 */


export var StyledStepperGroup = chakra("div", {
  themeKey: "NumberInput.StepperGroup",
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    top: "0",
    zIndex: 1
  },
  attrs: {
    "aria-hidden": true
  }
});
/**
 * NumberInputStepper
 *
 * React component used to group the increment and decrement
 * button spinners.
 *
 * It renders a `div` by default.
 *
 * @see Docs http://chakra-ui.com/components/number-input
 */

export var NumberInputStepper = /*#__PURE__*/React.forwardRef(function NumberInputStepper(props, ref) {
  var theming = useThemingContext();
  return /*#__PURE__*/React.createElement(StyledStepperGroup, _extends({
    ref: ref
  }, theming, props));
});

if (__DEV__) {
  NumberInputStepper.displayName = "NumberInputStepper";
}
/**
 * NumberInputField - Theming
 *
 * By default, the number input field inherits the theming
 * of the `Input` component.
 */


var StyledInput = chakra("input", {
  themeKey: "Input",
  baseStyle: {
    width: "100%"
  },
  shouldForwardProp: function shouldForwardProp(prop) {
    return !["focusBorderColor", "errorBorderColor"].includes(prop);
  }
});
/**
 * NumberInputField
 *
 * React component that represents the actual `input` field
 * where users can type to edit numeric values.
 *
 * It renders an `input` by default and ensures only numeric
 * values can be typed.
 *
 * @see Docs http://chakra-ui.com/numberinput
 */

export var NumberInputField = /*#__PURE__*/forwardRef(function NumberInputField(props, ref) {
  var theming = useThemingContext();

  var _useNumberInputContex = useNumberInputContext(),
      getInputProps = _useNumberInputContex.getInputProps;

  var htmlProps = getInputProps(_extends({}, props, {
    ref: ref
  }));
  return /*#__PURE__*/React.createElement(StyledInput, _extends({}, theming, {
    //@ts-ignore `size` is a valid `input` prop and it clashes with the size theming prop.
    size: theming == null ? void 0 : theming.size
  }, htmlProps));
});

if (__DEV__) {
  NumberInputField.displayName = "NumberInputField";
}
/**
 * NumberInputStepper - Theming
 *
 * To style the number input's stepper buttons globally, change the styles in
 * `theme.components.NumberInput` under the `Stepper` key
 *
 */


export var StyledStepper = chakra("div", {
  themeKey: "NumberInput.Stepper",
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    transition: "all 0.3s",
    userSelect: "none",
    cursor: "pointer",
    lineHeight: "normal"
  }
});
/**
 * NumberDecrementStepper
 *
 * React component used to decrement the number input's value
 *
 * It renders a `div` with `role=button` by default
 */

export var NumberDecrementStepper = /*#__PURE__*/React.forwardRef(function NumberDecrementStepper(props, ref) {
  var _props$children;

  var theming = useThemingContext();

  var _useNumberInputContex2 = useNumberInputContext(),
      getDecrementButtonProps = _useNumberInputContex2.getDecrementButtonProps;

  var htmlProps = getDecrementButtonProps(_extends({}, props, {
    ref: ref
  }));
  return /*#__PURE__*/React.createElement(StyledStepper, _extends({}, theming, htmlProps), (_props$children = props.children) != null ? _props$children : /*#__PURE__*/React.createElement(TriangleDownIcon, null));
});

if (__DEV__) {
  NumberDecrementStepper.displayName = "NumberDecrementStepper";
}
/**
 * NumberIncrementStepper
 *
 * React component used to increment the number input's value
 *
 * It renders a `div` with `role=button` by default
 */


export var NumberIncrementStepper = /*#__PURE__*/forwardRef(function NumberIncrementStepper(props, ref) {
  var _props$children2;

  var theming = useThemingContext();

  var _useNumberInputContex3 = useNumberInputContext(),
      getIncrementButtonProps = _useNumberInputContex3.getIncrementButtonProps;

  var htmlProps = getIncrementButtonProps(_extends({}, props, {
    ref: ref
  }));
  return /*#__PURE__*/React.createElement(StyledStepper, _extends({}, theming, htmlProps), (_props$children2 = props.children) != null ? _props$children2 : /*#__PURE__*/React.createElement(TriangleUpIcon, null));
});

if (__DEV__) {
  NumberIncrementStepper.displayName = "NumberIncrementStepper";
}